import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface DocumentFilters {
  open?: boolean;
  search: string;
}

type DocumentsPanelState = {
  filters: DocumentFilters;
};

export const INITIAL_DOCUMENTS_PANEL_STATE: DocumentsPanelState = {
  filters: {
    open: false,
    search: '',
  },
};

const DocumentsPanelSlice = createSlice({
  name: 'documentsPanel',
  initialState: INITIAL_DOCUMENTS_PANEL_STATE,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<DocumentFilters>>) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
});

export const { setFilters } = DocumentsPanelSlice.actions;

export default DocumentsPanelSlice.reducer;
